export const TAB_COMMON = 'common';
export const TAB_POPULAR = 'popular';

export const SELECTED_OPTION_RADIO = 'radio';
export const SELECTED_OPTION_CHECKBOX = 'checkbox';

export const VALUE_TYPE_REGION = 'region';
export const VALUE_TYPE_MARKET = 'market';

export const LOCALE_CN = 'zh-CN';
export const LOCALE_EN = 'en-US"';

export const locale = {
  en: {
    common: 'Common',
    popular: 'Key Country/Market',
    radio_title: 'Overall',
    region_title: 'Region',
    market_title: 'Country/Market',
    shortcut_title: 'Shortcut',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Region',
    button_market: 'Country/Market',
    button_all: 'All',
    search_none: 'No result found',
    country_no_data: 'No result found',
    aggregated_data_under_global: `Global: Shows the total value in global countries. It is shown directly and independently, but not the aggregate value of all available countries below.  For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, it's the weighted average data of 37 countries.`,
    aggregated_data_under_global_except: `Global except China mainland: Shows the total value in global countries except China mainland. We use global data minus data of China mainland. For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, there's no data of China and it's the weighted average data of 37 countries.`,
    global_global_wo_china_tips_of_top_companies: 'Here display the aggregated value of all available countries below. 70 countries for mobile game data and US/UK/FR/DE/ES for PC & Console game data.',
  },
  cn: {
    common: '全部',
    popular: '重点关注国家/市场',
    radio_title: '聚合数据',
    shortcut_title: '快捷键',
    region_title: '区域',
    market_title: '国家/市场',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_all: '全部',
    button_region: '区域',
    button_market: '国家/市场',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
    aggregated_data_under_global: '全球：展示全球整体数据。直接通过统计模型所得，不是所有国家的加总。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，是37个国家的月活加权平均值。',
    aggregated_data_under_global_except: '海外：展示全球除了中国大陆之外的数据。通过全球数据减去中国大陆所得。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，因为没有中国数据，所以海外数据和全球数据相同，是37个国家的月活加权平均值。',
    global_global_wo_china_tips_of_top_companies: '这里显示下面所有可用国家/地区的合计值。 提供70 个国家/地区的手机游戏数据以及美英法德西的 PC 和主机游戏数据。',
  }
};
